// Collections live in content/ and are edited in DataTrek.
// Re-exported here so existing imports keep working.
import testimonialsData from "../content/testimonials.json";
export const testimonials = testimonialsData;
